/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Authentication route guard
 *
 * Protects application routes through the provider-neutral authentication
 * contract so routing does not depend on an identity-provider SDK.
 */

import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {firstValueFrom} from 'rxjs';

import {AUTHENTICATION_PROVIDER} from '../../services/authentication/authentication-provider.token';

/**
 * Allows authenticated users to activate a route and starts login otherwise.
 *
 * @param _route - The route being activated.
 * @param state - The target router state used as the post-login return route.
 * @returns A promise resolving to whether the route activation is allowed.
 */
export const authenticationGuard: CanActivateFn = async (_route, state) => {
  const authenticationProvider = inject(AUTHENTICATION_PROVIDER);
  const isAuthenticated = await firstValueFrom(
    authenticationProvider.isAuthenticated$,
  );

  if (isAuthenticated) {
    return true;
  }

  await authenticationProvider.login({returnUrl: state.url});
  return false;
};
